import { z } from "zod";
export const WorkspaceBusinessIdentityV1Schema = z
    .object({
    schemaVersion: z.literal("workspace-business-identity.v1.0"),
    localTargetedProofComplete: z.literal(true),
    hostedOrExternalProofClaimed: z.literal(false),
    recordedAt: z.string().datetime(),
})
    .strict();
export function recordLocalWorkspaceBusinessIdentity(recordedAt) {
    return WorkspaceBusinessIdentityV1Schema.parse({
        schemaVersion: "workspace-business-identity.v1.0",
        localTargetedProofComplete: true,
        hostedOrExternalProofClaimed: false,
        recordedAt,
    });
}
//# sourceMappingURL=workspace-business-identity.js.map